
{
  "add-existing": "Add Job",
  "add-new": "Add New Job",
  "empty": "You have already added all of the existing jobs. Try creating a new job.",
  "title": "Add Existing Job"
}
